export const fallbackColor = 'red';
